'use client';

import { PolicyPage } from 'components/organisms/PolicyPage';

const TermsPage = () => <PolicyPage id="0793c84d-d1e3-4951-b2aa-75ed3a1f8c84" />;

export default TermsPage;
